import React, { ReactNode, useEffect, useState } from 'react'
import { Helmet } from '@dr.pogodin/react-helmet'
import Divider from '@mui/material/Divider'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import { Link } from 'react-router'
import { PressReleaseListItem } from '@finance-lab/utils/types'
import { PressReleaseApi } from '../../../api/PressReleasesApi'
import { getPressReleaseLink } from '../../../utils/get-press-release-link'

const pressReleaseApi = new PressReleaseApi()

export const AdminEditEntityWrapper = ({
    children,
    companyId,
    entityLink,
    entityStatus,
    pageTitle,
}: {
    companyId?: string
    children: ReactNode
    entityLink: string
    entityStatus?: ReactNode
    pageTitle: string
}) => {
    const [latestPressRelease, setLatestPressRelease] = useState<PressReleaseListItem | null>(null)

    useEffect(() => {
        const fetchData = async () => {
            if (!companyId) return

            const pr = await pressReleaseApi.allPressReleases({ page: 0, pageSize: 1 }, { companyId })
            setLatestPressRelease(pr.data[0] ?? null)
        }

        void fetchData()
    }, [companyId])

    return (
        <>
            <Helmet title={pageTitle} />
            <Typography
                variant='h3'
                gutterBottom
                sx={{
                    display: 'block',
                }}
            >
                {pageTitle}
            </Typography>
            <Stack direction='row' spacing={4}>
                {entityStatus}
                <Typography variant='body1'>
                    <Link to={entityLink}>[Visa detaljvy]</Link>
                </Typography>
                {companyId ? (
                    <Typography variant='body1'>
                        <Link to={`/companies/${companyId}`}>[Visa bolagsvy]</Link>
                    </Typography>
                ) : null}
                {latestPressRelease && companyId && (
                    <Typography variant='body1'>
                        <Link to={getPressReleaseLink(companyId, latestPressRelease.id)}>[Visa pm]</Link>
                    </Typography>
                )}
                {companyId && (
                    <Typography variant='body1'>
                        <Link to={`/admin/pr-company?companyId=${companyId}`}>[Visa admin pm]</Link>
                    </Typography>
                )}
            </Stack>
            <Divider sx={{ marginY: 6 }} />
            {children}
        </>
    )
}
